var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-logo",class:{'dev': !_vm.isProd()},on:{"click":_vm.goToHome}},[_c('img',{staticClass:"img-logo"}),(_vm.showBeta)?_c('img',{staticClass:"beta-logo",attrs:{"src":"images/beta.png"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }